const strings = {
  header: {
    employee: 'Employee',
    status: 'Status',
    phoneNumber: 'Phone Number',
  },
  cells: {
    unassignedPhoneNumber: 'Not assigned',
  },
} as const;

export default strings;
